<template>
    <div class="role-select">
        <div class="voice-box">
            <div class="type-select-box">
                <TypeSelect
                    :isContent="isContent"
                    :form.sync="typeSelectData"
                    :select.sync="typeSelect"
                    @onTypeSelect="onTypeSelect"
                />
            </div>
            <div class="list-select-box">
                <ListSelect
                    :form.sync="listSelectData"
                    :select.sync="listSelectRole"
                />
                <div
                    v-if="isContent"
                    class="text-box">
                    <p class="word">转化文本内容</p>
                    <el-input
                            class="text"
                            type="textarea"
                            :autosize="{ minRows: 4}"
                            placeholder="多音字语音合成文本举例：音乐[yue4]家"
                            v-model="text">
                    </el-input>
                </div>
                <div
                    v-if="isFileName"
                    class="text-box">
                    <p class="word"><span class="warn">*</span>语音文件名称</p>
                    <el-input
                            class="text"
                            placeholder="请输入语音文件名称"
                            v-model="fileName">
                    </el-input>
                </div>
                <VoiceChange
                    :form.sync="voiceChangeData"
                    @onVoiceTry="onVoiceTry"
                />
                <!--<Btns-->
                    <!--:form.sync="btnsData"-->
                    <!--@success="onSuccess"-->
                    <!--@cancel="handleClose"-->
                <!--/>-->
            </div>
        </div>
        <span class="dialog-footer">
            <el-button @click="handleClose">取 消</el-button>
            <el-button type="primary" @click="onSuccess">确 定</el-button>
          </span>
    </div>
</template>

<script>
    // import  XunfeiTTS from 'xf-tts-socket'
    // const { promisify } = require('util');
    // const getXunfeiTTSAsync = promisify(XunfeiTTS);
    import TypeSelect from './components/typeSelect'
    import ListSelect from './components/listSelect'
    import VoiceChange from './components/voiceChange'
    // import Btns from './components/btns'

    import {AudioPlay} from "../../../../utils/audio";
    import {roles} from "./roles";
    import * as GlobalServer from '../../../../api/global'

    export default {
        name: "ai-select",
        components: {
            TypeSelect,
            ListSelect,
            VoiceChange,
            // Btns
        },
        props: {
            isContent: Boolean,
            isFileName: Boolean,
            visible: Boolean,
            selectRole: [Number, String],
            defaultValue: Object
        },
        computed: {
            // -500~500
            spd(){
                let value = this.voiceChangeData[0].value
                return 10 * value - 500
            },
            // 0~100
            vol(){
                let value = this.voiceChangeData[1].value
                return value
                // return Math.ceil(value/100 * 15)
            },
            newRoles(){
                let arr = []
                Object.entries(roles).map(v=>arr.push(v))
                return arr
            },
        },
        watch: {
            visible(vl){this.dialogVisible = vl},
            dialogVisible(vl){this.$emit('update:visible', vl)},
            selectRole(vl){this.listSelectRole = vl},
            listSelectRole(vl){this.$emit('update:selectRole', vl)},
        },
        created () {
            this.init()
        },
        data(){
            return {
                dialogVisible: this.visible,
                typeSelectData: Object.keys(roles).map((v,i)=>{ return {id: i, name: v}}),
                typeSelect: '',
                listSelectRole: this.selectRole,
                listSelectData: [],
                voiceChangeData: [
                    {name: '配音语速', value: 50},
                    {name: '配音音量', value: 50},
                ],
                btnsData: [
                    {key: 'success', name: '确定'},
                    {key: 'cancel', name: '取消'},
                ],
                fileName: `默认名称【${(Math.random() * 100000).toFixed(0)}】`, // 语音文件名称
                text: this.defaultValue.text // 语音合成文本
            }
        },
        methods: {
            init () {
                console.log('初始化参数', this.defaultValue, `${this.defaultValue.spd}`)
                if(`${this.defaultValue.spd}` !== 'undefined') this.voiceChangeData[0].value = (this.defaultValue.spd+500) / 10
                if(`${this.defaultValue.vol}` !== 'undefined') this.voiceChangeData[1].value = this.defaultValue.vol
                if(`${this.defaultValue.typeSelect}` !== 'undefined') {
                    this.typeSelect = this.defaultValue.typeSelect
                    this.onTypeSelect({id:this.typeSelect})
                }
                if(this.defaultValue.per !== 'undefined') this.listSelectRole = this.defaultValue.per
            },
            onTypeSelect(item){
                this.listSelectData = this.newRoles[item.id][1].map(v=>{
                    return {
                        id: v.type,
                        name: v.name
                    }
                })
            },
            getIndexByPer (key) {
                let index = 0
                this.listSelectData.map((v,i)=>{
                    if(`${v.id}` === `${key}`){
                        index = i
                    }
                })
                return index
            },
            handleClose() {
                this.dialogVisible = false
                this.$emit('success')
            },
            async submit() {
                let state = this.$refs.form.validateForm()
                if(state){
                    this.handleClose()
                }
            },
            // 试听
            async onVoiceTry(){
                if(!this.listSelectRole){
                    this.$message.error('您还未选择说话角色')
                    return false
                }
                // Word2Voice({text:'我是试听声音', spd: this.spd, vol: this.vol, per: this.listSelectData[this.listSelectRole].id})
                const word = '请输入语音合成内容!'
                let work = this.defaultValue.text || word

                if(this.isContent) {
                    work = this.text || word
                }
                work=this.textToTTS(work);
                // 生成阿里云音频文件
                const res = await GlobalServer.getVoiceByAliyun({
                    work,
                    voice: this.listSelectRole,
                    volume: this.vol,
                    speech_rate: this.spd
                })
                console.log('阿里云res==>', res)
                // 播放试听音频
                if(res.url){
                    AudioPlay({url: res.url})
                }
            },
            async onSuccess(){
                if(!this.listSelectRole){
                    this.$message.error('请选角色')
                    return false
                }
                if(this.isContent && !this.text){
                    this.$message.error('请输入内容')
                    return false
                } else if (this.isFileName && !this.fileName) {
                    this.$message.error('请输入语音文件名称')
                    return false
                }
                let per = this.listSelectRole
                let obj = {typeSelect: this.typeSelect, spd: this.spd, vol: this.vol, per, text: this.text}

                // 如果有文本域 & 文件名，优先判断
                if(this.text && this.fileName) {
                    let work=this.textToTTS(this.text);
                    const res = await GlobalServer.getVoiceByAliyun({
                        work: work,
                        voice: this.listSelectRole,
                        volume: this.vol,
                        speech_rate: this.spd
                    })

                    if(res.url) obj['url'] = res.url

                    if(this.fileName) obj['fileName'] = this.fileName

                    this.$emit('onXunfei', obj)
                    return false
                }
                // 只有文件名
                else if(this.fileName) {
                    obj.voice = this.listSelectRole
                    obj.volume = this.vol
                    obj.speech_rate = this.spd
                    obj.fileName = this.fileName
                    this.$emit('onXunfei', obj)
                    return false
                }

                this.$emit('onXunfei', obj)
                this.handleClose()
            },
            textToTTS(str){
                let arr=str.split("]");//js中的字符串split方法能用正则表达式
                let sarr=[];//当前子字符串
                let ssarr=[];//当前子字符串分割成单个文字
                let nstr="";//转码后文本
                for(let i=0;i<arr.length;i++){
                    sarr=arr[i].split("[");//将[字符转数组
                    ssarr=sarr[0].split('');
                    //console.log("当前字段详情：",sarr);
                    for(let j=0;j<ssarr.length-1;j++){
                        nstr+=ssarr[j];
                        //console.log("当前文字：",nstr);
                    }
                    
                    nstr+=(sarr.length>1)?'<phoneme alphabet="py" ph="'+sarr[1]+'">'+ssarr[ssarr.length-1]+'</phoneme>':((sarr.length==0 || ssarr.length==0)?"":ssarr[ssarr.length-1]);
                }
                console.log("转码后文本","<speak>"+nstr+"</speak>");
                return "<speak>"+nstr+"</speak>";
            }
        }
    }
</script>
<style lang="scss" scoped>
.role-select {
    .voice-box {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;

        /deep/ .voice-box{
            display: flex;
            flex-direction: row;
        }

        .title {
            position: absolute;
            top: 0px;
            left: 0px;
            line-height: 24px;
            font-size: 20px;
            color: white;
            background-color: #303133;
            width: 100px;
            height: 34px;
            padding-top: 22px;
            padding-left: 25px;
        }

        .type-select-box {
            flex-shrink: 0;
            display: flex;
            flex-direction: column;
            align-items: center;

            /deep/ .type-select{
                display: flex;
                flex-direction: row;
                align-items: center;
                width: 100%;

                .item{
                    padding-left: 10px;
                }

                &:before{
                    display: none;
                }
            }
        }

        .list-select-box {
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            margin-left: 10px;
            margin-top: 30px;

            .text-box {
                margin: 10px;
                width: calc(100% - 40px);

                .word {
                    font-size: 14px;
                    font-weight: 400;
                    color: rgba(0, 0, 0, 1);
                    line-height: 16px;

                    .warn {
                        color: red;
                        margin-right: 4px;
                        position: relative;
                        top: 1px
                    }
                }

                .text {
                    margin-top: 10px;
                    width: 100%;
                }
            }
        }
    }
    .dialog-footer{
        display: flex;
        flex-direction: row;
        justify-content: flex-end;
        margin: 20px;
        margin-right: 30px;
    }
}
</style>
